module.exports = __webpack_public_path__ + "static/media/29DUNON11.c78e930b.jpg";